export default "__VITE_ASSET__BBC7lfjK__"